import {Component, DestroyRef, effect, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatDialog} from '@angular/material/dialog';
import {AdxErpPanelFilterService} from '../service/adx-erp-panel-filter.service';
import {AdxErpFilterModalComponent} from '../components/adx-erp-filter-modal/adx-erp-filter-modal.component';

@Component({
  selector: 'app-adx-erp-panel',
  templateUrl: './adx-erp-panel.component.html',
  standalone: false,
})
export class AdxErpPanelComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly filterService = inject(AdxErpPanelFilterService);

  constructor() {
    effect(() => {
      const open = this.filterService.toggleModal();
      if (!open) return;
      this.openFilters();
    });
  }

  private openFilters(): void {
    const dialog = this.dialog.open(AdxErpFilterModalComponent, {width: '700px', panelClass: 'adx-erp-filter-dialog'});
    dialog.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.filterService.toggleModal.set(false);
      });
  }
}
